<template>
  <div class="mb-4">
    <div v-if="!isVoted">
      <b-card no-body class="border-none px-4 mb-6">
        <!-- <div class="flex items-center">
          <img alt="user" class="w-9 rounded-full" :src="item.userImg" />
          <p class="font-bold text-sm ml-4">
            {{ data._user.firstname }} {{ data._user.lastname }}
            <span class="font-normal"> has started a poll </span>
          </p>
        </div> -->

        <div class="mt-0 mb-2">
          <p class="text-base font-semibold">
            {{ data.poll.question }}
          </p>
        </div>
        <!-- <div class="mt-2">
          <p class="text-sm font-normal leading-6 text-muted">
            {{ "dsa" }}
          </p>
        </div> -->
        <!-- <div class="mt-5">
          <b-form-radio
            v-for="choice in data.poll.choices"
            :key="choice._id"
            @change="() => (selected = choice._id)"
            name="some-radios"
            :value="choice._id"
            class="rb-btn-txt"
            >{{ choice.text }}</b-form-radio
          >
        </div> -->
        <b-card
          no-body
          class="rounded-lg p-2 text-left my-2 qcard cursor-pointer"
          v-for="choice in data.poll.choices"
          :key="choice._id"
          @click="
            () => {
              selected = choice._id;
              votePoll();
            }
          "
        >
          <b-form-radio
            v-model="selected"
            name="some-radios"
            :value="choice._id"
            :disabled="!!!selected"
            class="radiowhite"
          >
            <p class="font-normal">
              {{ choice.text }}
            </p></b-form-radio
          >
        </b-card>
        <!-- <div class="mt-4 w-full flex justify-center">
          <base-button
            type="primary"
            :disabled="!!!selected"
            class="rounded-lg w-1/4"
            @click="votePoll()"
            >VOTE</base-button
          >
        </div> -->
      </b-card>
    </div>
    <div v-show="isVoted">
      <PollResult :data="data" />
    </div>
  </div>
</template>
<script>
import PollResult from "./PollResult.vue";
import { mapState } from "vuex";
export default {
  components: {
    PollResult,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    async votePoll() {
      let loader = this.$loading();
      let votePoll = {
        choiceId: this.selected,
        questionId: this.data.poll._id,
        postId: this.data._id,
      };
      try {
        await this.$store.dispatch("posts/votePoll", votePoll);
        this.isVoted = true;
        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
  },
  computed: {
    ...mapState("auth", {
      userData: "user",
    }),
  },
  data() {
    return {
      selected: "",
      isVoted: false,
    };
  },
  mounted() {
    let self = this;
    let AllVotes = this.data.poll.choices.map((x) => x.votes).flat();
    this.isVoted = AllVotes.filter(
      (vote) => vote._user == self.userData._id
    ).length;
  },
};
</script>
